<div fxLayout="row" class="snack-container">
    <div>
      <mat-icon>{{getIcon}}</mat-icon>
    </div>
    <div>
      <span class="toast">{{data.message}}</span>
    </div>
</div>
